var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.5,
    stroke: "#323657"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.245 10.953V8.68c.786-.036 1.4-.221 1.841-.554.451-.332.677-.79.677-1.37v-.195c0-.47-.154-.845-.46-1.122-.308-.286-.72-.429-1.238-.429-.557 0-1.003.152-1.338.457a2.297 2.297 0 0 0-.662 1.164L6 6.244c.086-.296.211-.577.374-.845a2.9 2.9 0 0 1 1.54-1.219c.345-.12.743-.18 1.194-.18.892 0 1.597.235 2.115.706.518.471.777 1.108.777 1.912 0 .443-.082.83-.245 1.163-.153.323-.355.6-.604.831-.25.231-.532.416-.849.554a4.152 4.152 0 0 1-.95.291v1.496H8.246ZM8.805 14c-.306 0-.532-.074-.675-.222-.135-.147-.202-.341-.202-.581v-.18c0-.24.067-.434.202-.582.143-.148.369-.222.676-.222.307 0 .527.074.662.222a.798.798 0 0 1 .215.582v.18c0 .24-.071.434-.215.581-.135.148-.355.222-.662.222Z",
    fill: "#323657"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c74e1e2e73d84ac708e1369d8b15097d.svg";
export { ForwardRef as ReactComponent };